/* eslint-disable @typescript-eslint/no-namespace */
// NOTE put constants which are specific to this application.
/** Current application constants */
export namespace APP_CONSTANTS {
    export const AppName = 'GEOLOKETLB';
    export const AppBui = AppName + 'BUI';
    export const AppWeb = AppName + 'WEB';
    export const AppWebPrefix = AppWeb + '\\';

    export namespace ActieClaims {
        const Prefix = AppWebPrefix;
        export const Gebruiken = Prefix + 'Gebruiken';
        export const TechRaadplegen = Prefix + 'TechRaadplegen';
    }

    /** Profiel (beheer) constants. */
    export namespace Profiel {
        export namespace Bui {
            const Prefix = '\\GeoLoketLb\\Bui\\';
            export const HelpLinkConsultatieKaart = Prefix + 'HelpLinkConsultatieKaart';
        }
    }
}
